import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import * as parentService from '../admin/services/authParentService'

export const ConfirmEmail = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const regId = query.get('regId');
        const token = query.get('token');
        const email = query.get('email');
        const cn = query.get('cn');
        const isUserExisted = query.get('isExisted');



        const confirmEmail = async () => {
            try {
                const encodedToken = encodeURIComponent(token);
                const response = await parentService.confirmEmail(encodedToken, email, cn)

                if (isUserExisted == 'True') {
                    navigate(`/parent-login`)
                } else {
                    navigate(`/register?regId=${regId}`)
                }
            } catch (error) {
                console.log("Error confirming email.");
            }
        };

        confirmEmail();
    }, [location]);

    return (
        <div>
            <h2>Email Confirmation...</h2>
        </div>
    );
}